(() => {
  if (customElements.get('pn-closing-video')) return;
  class ClosingVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.mobile = matchMedia('(max-width: 699px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.pausedByUser = false;
      this.inView = false;
      this.failed = false;
      this.cleanups = [];
      const on = (target, event, fn) => {
        target.addEventListener(event, fn);
        this.cleanups.push(() => target.removeEventListener(event, fn));
      };
      on(this.mobile, 'change', () => { this.unload(); this.failed = false; this.update(); });
      on(this.reduced, 'change', () => { this.unload(); this.update(); });
      on(document, 'visibilitychange', () => this.update());
      on(this.video, 'playing', () => {
        if (this.reduced.matches || !this.inView || this.pausedByUser || document.hidden) {
          this.video.pause(); return;
        }
        this.setAttribute('data-playing', '');
      });
      on(this.video, 'pause', () => { this.removeAttribute('data-playing'); });
      on(this.video, 'error', () => { this.failed = true; this.unload(); });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting; this.update();
        }, { threshold: 0 });
        this.observer.observe(this);
      } else { this.inView = true; }
      this.update();
    }
    unload() {
      this.video.pause();
      this.removeAttribute('data-playing');
      this.video.autoplay = false;
      this.video.removeAttribute('src');
      this.video.load();
    }
    update() {
      const src = this.mobile.matches ? this.dataset.mobile : this.dataset.desktop;
      const poster = this.mobile.matches ? this.dataset.posterMobile : this.dataset.posterDesktop;
      if (poster && this.video.getAttribute('poster') !== poster) this.video.poster = poster;
      if (this.reduced.matches || this.failed || !src) { this.video.pause(); return; }
      if (!this.inView || document.hidden || this.pausedByUser) { this.video.pause(); return; }
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.autoplay = true;
      if (this.video.getAttribute('src') !== src) {
        this.video.src = src; this.video.load();
      }
      // Autoplay runs only for visible media; rejection keeps the responsive poster.
      const play = this.video.play();
      if (play) play.catch(() => { this.removeAttribute('data-playing'); });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.cleanups?.forEach(cleanup => cleanup());
      if (this.video) this.unload();
    }
  }
  customElements.define('pn-closing-video', ClosingVideo);
})();
